<template>
    <div>
        <v-container>
            <v-col class="d-flex" cols="12" sm="6">
                <!-- Selector de Año -->
                <v-select dense v-model="año" :items="años" label="Seleccione un año" @change="loadDisabledDays"></v-select>

                <!-- Selector de Semestre -->
                <v-select dense v-model="semestre" :items="semestres" item-value="id" item-text="nombre"
                    label="Seleccione un semestre" @change="loadDisabledDays"></v-select>
            </v-col>
            <!-- Calendario -->
            <v-row dense v-if="año">
                <v-col cols="12" md="4" lg="4" v-for="(mes, index) in meses" :key="index"
                    v-if="mes.semestre == semestre">
                    <v-card dense color="orange">
                        <v-card-title class="pa-1 white--text">{{ mes.mes }}</v-card-title>
                        <v-sheet>
                            <table class="calendar-table">
                                <thead>
                                    <tr>
                                        <th v-for="(weekday, index) in diaSemana" :key="'weekday-' + index">{{ weekday
                                            }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(week, weekIndex) in getWeeksInMonth(index + 1, año)"
                                        :key="'week-' + weekIndex">
                                        <td v-for="(day, dayIndex) in week" :key="dayIndex"
                                            :class="getDiaClass(day)"
                                            @click="day && toggleDay(day)">
                                            {{ day ? day.split('-')[2] : '' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-sheet>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Planificador from "../../services/Planificador.service"
export default {
    props: {
        dias: {
            required: true,
        }
    },
    data() {
        return {
            año: null,
            semestre: null,
            años: [2024, 2025, 2026, 2027, 2028, 2029],
            semestres: [{ id: 1, nombre: "Primer Semestre" }, { id: 2, nombre: "Segundo Semestre" }],
            meses: [
                { mes: "Enero", semestre: 1 },
                { mes: "Febrero", semestre: 1 },
                { mes: "Marzo", semestre: 1 },
                { mes: "Abril", semestre: 1 },
                { mes: "Mayo", semestre: 1 },
                { mes: "Junio", semestre: 1 },
                { mes: "Julio", semestre: 2 },
                { mes: "Agosto", semestre: 2 },
                { mes: "Septiembre", semestre: 2 },
                { mes: "Octubre", semestre: 2 },
                { mes: "Noviembre", semestre: 2 },
                { mes: "Diciembre", semestre: 2 },
            ],
            diaSemana: ["L", "M", "M", "J", "V", "S", "D"],
            disabledDays: [], // Días no habilitados
            loading: false,
        };
    },
    methods: {
        // Generar semanas del mes
        getWeeksInMonth(month, year) {
            const firstDay = new Date(year, month - 1, 1);
            const lastDay = new Date(year, month, 0);
            const weeks = [];
            let currentWeek = Array(7).fill(null);

            // Ajustar índice para que la semana inicie en lunes
            let startIndex = (firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1);

            // Rellenar días iniciales
            for (let i = 0; i < startIndex; i++) {
                currentWeek[i] = null;
            }

            // Rellenar días del mes
            for (let day = 1; day <= lastDay.getDate(); day++) {
                const date = new Date(year, month - 1, day);
                const adjustedDay = (date.getDay() === 0 ? 6 : date.getDay() - 1);
                currentWeek[adjustedDay] = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

                // Si es domingo (final de la semana) o último día del mes, cerrar la semana
                if (adjustedDay === 6 || day === lastDay.getDate()) {
                    weeks.push(currentWeek);
                    currentWeek = Array(7).fill(null);
                }
            }
            return weeks;
        },
        loadDisabledDays() {

        },
        // Verifica si un día está deshabilitado
        getDiaClass(day) {
            console.log(day);
            if (!day) {
                return { empty: true }; // Día vacío
            }
            const fechaStr = day + "T00:00:00"; // Formato ISO
            const estado = this.dias.get(fechaStr);
            return {
                habilitado: estado === 1,
                ocupado: estado === 2,
                noDisponible: estado === 3,
                empty: estado === undefined // Si no está en los registros
            };
        },
        // Alterna el estado de un día
        async toggleDay(day) {
            if (!day) return;
            const fechaStr = day + "T00:00:00"; // Formato ISO
            const estado = this.dias.get(fechaStr);
            if(estado===1 || estado===2)
                this.$emit('click-dia', day);

           
        },
    },
    mounted() {
        //dev modicficar al actual mes año
        this.año = new Date().getFullYear()
        this.semestre = (new Date().getMonth() < 7) ? 1 : 2;
    },
};
</script>

<style>
.calendar-table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
}

.calendar-table th,
.calendar-table td {
    border: 1px solid #ddd;
    width: 14.2%;
    /* 7 columnas */
    height: 50px;
    cursor: pointer;
}

.calendar-table td.empty {
    background-color: #f5f5f5;
    cursor: default;
}

.calendar-table td:hover {
    background-color: #78b6f9;
}

.calendar-table td.disabled {
    background-color: #f8d7da;
    color: #721c24;
}


.habilitado {
    background-color: green;
    color: white;
}
.habilitado:hover {
    background-color: rgb(131, 241, 131);
    color: black;
}
.ocupado {
    background-color: orange;
    color: black;
}

.noDisponible {
    background-color: red;
    color: white;
}

.empty {
    background-color: lightgray;
    color: black;
}
</style>